import _Typography from "@mui/material/Typography";
import _IconButton from "@mui/material/IconButton";
import _ChevronRight from "@mui/icons-material/ChevronRight";
import _Skeleton from "@mui/material/Skeleton";
import _Tooltip from "@mui/material/Tooltip";
import _ChevronLeft from "@mui/icons-material/ChevronLeft";
import moment from 'moment';
import React from 'react';
import { styled } from 'styled-components';
const now = moment();
export function PeriodSelector({
  type,
  period,
  dates,
  nextPeriodTooltip,
  onPeriodSelected,
  onDateIndexSelected,
  prevPeriodTooltip,
  selectedDateIndex
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "bottom",
    title: prevPeriodTooltip
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(StyledPrevButton, {
    disabled: !period && (!dates || selectedDateIndex === 0 || selectedDateIndex === -1),
    onClick: () => period ? onPeriodSelected?.(period.getPrevPeriod()) : selectedDateIndex !== undefined && onDateIndexSelected?.(selectedDateIndex - 1),
    size: "small"
  }, /*#__PURE__*/React.createElement(_ChevronLeft, null)))), period ? /*#__PURE__*/React.createElement(StyledTitle, {
    align: "center",
    className: type
  }, period.from.format(type === 'year' ? 'YYYY' : 'MMMM YYYY')) : selectedDateIndex !== undefined && dates?.[selectedDateIndex] ? /*#__PURE__*/React.createElement(StyledTitle, {
    align: "center",
    className: type
  }, dates[selectedDateIndex].format(type === 'year' ? 'YYYY' : 'MMMM YYYY')) : /*#__PURE__*/React.createElement(_Skeleton, {
    variant: "text",
    width: 100
  }), /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "bottom",
    title: nextPeriodTooltip
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(StyledNextButton, {
    disabled: period ? period.to.isAfter(now) : !dates || selectedDateIndex === dates.length - 1,
    onClick: () => period ? onPeriodSelected?.(period.getNextPeriod()) : selectedDateIndex !== undefined && onDateIndexSelected?.(selectedDateIndex + 1),
    size: "small"
  }, /*#__PURE__*/React.createElement(_ChevronRight, null)))));
}
const StyledPrevButton = styled(_IconButton)`
  && {
    margin-right: 8px;
  }
`;
const StyledTitle = styled(_Typography)`
  width: 120px;

  &.year {
    width: 60px;
  }
`;
const StyledNextButton = styled(_IconButton)`
  && {
    margin-left: 8px;
  }
`;